import { SearchEntrypoint } from '../../src/search/SearchEntrypoint/SearchEntrypoint';

// eslint-disable-next-line import/no-default-export
export default SearchEntrypoint;
